/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDefinitionKey } from './businessObjectDefinitionKey';


export interface UploadBusinessObjectDefinitionSampleDataFileInitiationResponse { 
    businessObjectDefinitionKey: BusinessObjectDefinitionKey;
    awsS3BucketName: string;
    s3Endpoint: string;
    s3KeyPrefix: string;
    awsAccessKey: string;
    awsSecretKey: string;
    awsSessionToken: string;
    awsKmsKeyId?: string;
    awsSessionExpirationTime: Date;
}
